'use strict';

/*global echo*/

(function ($) {
    var methods = {
        init: function (options) {
            return this.each(function () {
                var _this = this;
                var $this = $(this);

                if ($this.hasClass('rating-init')) {
                    return;
                }
                
                options = $.extend({}, $.fn.rating.defaults, options || {});
                
                $this.addClass('rating-init');

                $this.on('click', '.rating-icon', function () {
                    methods.select.apply(_this, [$(this), options]);
                    return false;
                });
                
                $this.on('mouseenter', '.rating-icon', function () {
                    methods.mouseenter.apply(_this, [$(this), options]);
                    return false;
                });
                
                $this.on('mouseleave', '.rating-icon', function () {
                    methods.mouseleave.apply(_this, [$(this), options]);
                    return false;
                });
            });
        },
        
        select: function ($current, options) {
            $(this).find('.rating-icon').each(function () {
                $(this).data('class', 'rating-icon ' + options.unselected);
                $(this).attr('class', 'rating-icon ' + options.unselected);
            });

            var icon = $current.prevAll('.rating-icon').add($current);
            icon.each(function () {
                $(this).data('class', 'rating-icon ' + options.selected);
                $(this).attr('class', 'rating-icon ' + options.selected);
            });
            
            $(this).find('input').val(icon.length).change();
        },
        
        mouseenter: function ($current, options) {
            $(this).find('.rating-icon').each(function () {
                $(this).data('class', $(this).attr('class'));
                $(this).attr('class', 'rating-icon ' + options.unselected);
            });

            var icon = $current.prevAll('.rating-icon').add($current);
            icon.each(function () {
                $(this).attr('class', 'rating-icon ' + options.selected);
            });
        },
        
        mouseleave: function ($current, options) {
            $(this).find('.rating-icon').each(function () {
                $(this).data('class', 'rating-icon ' + options.unselected);
                $(this).attr('class', 'rating-icon ' + options.unselected);
            });

            var icon = $(this).find('.rating-icon');            
            for(var i = 0; i < parseInt($(this).find('input').val()); i++) {
                icon.eq(i).data('class', 'rating-icon ' + options.selected);
                icon.eq(i).attr('class', 'rating-icon ' + options.selected);
            }  
        },
    };

    $.fn.rating = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exists on jQuery.rating');
        }
    };

    $.fn.rating.defaults = {
        selected: 'fa fa-star',
        unselected: 'far fa-star'
    };
})(jQuery);
